/**
 * Auto-inserts the "HH:mm" colon as digits are typed (e.g. "0930" -> "09:30"). Deletions are
 * passed through verbatim — reformatting them would re-insert a colon the user just backspaced
 * over, trapping the cursor.
 */
export const formatKioskTimeInput = (previous: string, raw: string): string => {
  if (raw.length < previous.length) {
    return raw;
  }
  const digits = raw.replace(/\D/g, '').slice(0, 4);
  return digits.length > 2 ? `${digits.slice(0, 2)}:${digits.slice(2)}` : digits;
};
